var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppRadioGroup',{staticClass:"checklist-item__type",attrs:{"checked-value":_vm.itemType,"options":_vm.radioOptions,"name":"task-type"},model:{value:(_vm.itemType),callback:function ($$v) {_vm.itemType=$$v},expression:"itemType"}})
}
var staticRenderFns = []

export { render, staticRenderFns }